module.exports = __webpack_public_path__ + "img/Ornate butterflyfish.0f293a70.png";